import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const DatabaseTablesByIdQueryGql: DocumentNode = gql`
query DatabaseTablesByIdQuery(
  $databaseId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  databases(filter: { id: $databaseId }) {
    tablesConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: tablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: tablesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
